import React from 'react';
import PropTypes from 'prop-types';
import {
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import Widget from 'components/Widget/index';
import styles from './WidgetRainbow.module.scss';

const WidgetRainbow = ({ title, mainNumber, description, pieData, tone }) => {
  const chartData = (pieData || []).map(item => ({
    ...item,
    value: Number.isFinite(Number(item.value)) ? Math.max(Number(item.value), 0) : 0,
  }));
  const hasChartData = chartData.some(item => item.value > 0);

  return (
    <Widget styleName={`jr-card-full noMargin ${styles.card} ${styles[tone] || ''}`}>
      <div className={styles.content} role="group">
        <div className={styles.metric}>
          <p className={styles.eyebrow}>{title}</p>
          <p className={styles.value}>{mainNumber}</p>
          <p className={styles.description}>{description}</p>
        </div>
        <div className={styles.chart} aria-hidden="true">
          {hasChartData ? (
            <ResponsiveContainer height={124} width="100%">
              <PieChart>
                <Pie
                  data={chartData}
                  cx="50%"
                  cy="50%"
                  innerRadius={38}
                  outerRadius={55}
                  paddingAngle={2}
                  dataKey="value"
                  isAnimationActive={false}
                >
                  {chartData.map(item => <Cell key={item.id || item.name} fill={item.fill} />)}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          ) : <div className={styles.emptyRing} />}
        </div>
      </div>
    </Widget>
  );
};

WidgetRainbow.propTypes = {
  title: PropTypes.node.isRequired,
  mainNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  description: PropTypes.node.isRequired,
  pieData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    fill: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })),
  tone: PropTypes.oneOf(['searches', 'clickRate', 'zeroResults', 'clickEvents', 'lostOpportunities']),
};

WidgetRainbow.defaultProps = {
  pieData: [],
  tone: 'searches',
};

export default WidgetRainbow;
